export default {
  UNKNOWN: 'UNKNOWN',
  VALID: 'VALID',
  INVALID: 'INVALID'
};
